// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.title{
    font: normal normal bold 16px/19px Helvetica Neue,sans-serif;
    font-size: 16px;
    font-weight: bold;
    /* color: var(--unnamed-color-2c906b); */
    text-align: left;
    /* font: normal normal bold 16px/19px Helvetica Neue; */
    letter-spacing: 0px;
    color: #2C906B;
    opacity: 1;
    margin-left: 20px;
    margin-top: 20px;
}

.desc{
    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;
    font-size: 16px;
    /* color: var(--unnamed-color-919191); */
    text-align: left;
    /* font: normal normal normal 16px/18px Helvetica Neue; */
    letter-spacing: 0px;
    color: #919191;
    opacity: 1;
    margin-left: 20px;
    margin-top: 10px;
}

.value{
    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;
    font-size: 16px;
    /* color: var(--unnamed-color-3b3b3b); */
    text-align: left;
    /* font: normal normal normal 16px/18px Helvetica Neue; */
    letter-spacing: 0px;
    color: #3B3B3B;
    opacity: 1;
    margin-left: 20px;
}

.line {
    border:none;
    border-top:3px dashed #A0D7C7;
    color:#fff;
    background-color:#fff;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 17px;
    margin-bottom: 17px;
  }

.list-group {
    margin-top: 10px;
    /* max-height: 400px; */
    max-height: 55vh;
    margin-bottom: 10px;
    overflow-y:scroll;
    outline: none;
}

.list-group-item:hover , .active, .highlight{
    background: var(--unnamed-color-f7ead3) 0% 0% no-repeat padding-box;
    background: #F7EAD3 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 2.5px;
    margin-top: 2.5px;
    width: 200px !important;
    height: 40px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    text-align: start;
}

.inactive{
    background: var(--unnamed-color-f7ead3) 0% 0% no-repeat padding-box;
    background: white 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 2.5px;
    margin-top: 2.5px;
    width: 200px !important;
    height: 40px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    text-align: start;
}

.list-group-item{
    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;
    height: 40px !important;
    width: 200px !important;
    margin-left: 20px;
    margin-right: 0px;
    margin-bottom: 2.5px;
    margin-top: 2.5px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    /* color: black; */
    font-size: 16px;
    /* font: normal normal normal 16px/18px Helvetica Neue; */
    /* color: var(--unnamed-color-3b3b3b); */
    /* text-align: left; */

    letter-spacing: 0px;
    color: #3B3B3B;
    opacity: 1;
    border: none;
    text-align: start;
}


/* @media only screen and (max-width: 1940px) {
    .list-group {
        max-height: 570px !important;
    }
}
@media only screen and (max-width: 1710px) {
    .list-group {
        max-height: 470px !important;
    }
}
@media only screen and (max-width: 1610px) {
    .list-group {
        max-height: 420px !important;
    }
} */
/**mac screen*/
/* @media only screen and (max-width: 1580px) {
    .list-group {
        max-height: 560px !important;
    }
}
@media only screen and (max-width: 1430px) {
    .list-group {
        max-height: 335px !important;
    }
} */
/**mac screen*/
/* @media only screen and (max-width: 1390px) {
    .list-group {
        max-height: 460px !important;
    }
} */
/**mac screen*/
/* @media only screen and (max-width: 1310px) {
    .list-group {
        max-height: 410px !important;
    }
}
@media only screen and (max-width: 1290px) {
    .list-group {
        max-height: 260px !important;
    }
} */
/**mac screen*/
/* @media only screen and (max-width: 1160px) {
    .list-group {
        max-height: 340px !important;
    }
} */
/**mac screen*/
/* @media only screen and (max-width: 1040px) {
    .list-group {
        max-height: 260px !important;
    }
} */`, "",{"version":3,"sources":["webpack://./src/app/core/hht/itinerary-map-details/itinerary-map-details.component.css"],"names":[],"mappings":";AACA;IACI,4DAA4D;IAC5D,eAAe;IACf,iBAAiB;IACjB,wCAAwC;IACxC,gBAAgB;IAChB,uDAAuD;IACvD,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,eAAe;IACf,wCAAwC;IACxC,gBAAgB;IAChB,yDAAyD;IACzD,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,eAAe;IACf,wCAAwC;IACxC,gBAAgB;IAChB,yDAAyD;IACzD,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mEAAmE;IACnE,+CAA+C;IAC/C,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,mEAAmE;IACnE,6CAA6C;IAC7C,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,8DAA8D;IAC9D,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,yDAAyD;IACzD,wCAAwC;IACxC,sBAAsB;;IAEtB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;;AAGA;;;;;;;;;;;;;;GAcG;AACH,cAAc;AACd;;;;;;;;;GASG;AACH,cAAc;AACd;;;;GAIG;AACH,cAAc;AACd;;;;;;;;;GASG;AACH,cAAc;AACd;;;;GAIG;AACH,cAAc;AACd;;;;GAIG","sourcesContent":["\n.title{\n    font: normal normal bold 16px/19px Helvetica Neue,sans-serif;\n    font-size: 16px;\n    font-weight: bold;\n    /* color: var(--unnamed-color-2c906b); */\n    text-align: left;\n    /* font: normal normal bold 16px/19px Helvetica Neue; */\n    letter-spacing: 0px;\n    color: #2C906B;\n    opacity: 1;\n    margin-left: 20px;\n    margin-top: 20px;\n}\n\n.desc{\n    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    font-size: 16px;\n    /* color: var(--unnamed-color-919191); */\n    text-align: left;\n    /* font: normal normal normal 16px/18px Helvetica Neue; */\n    letter-spacing: 0px;\n    color: #919191;\n    opacity: 1;\n    margin-left: 20px;\n    margin-top: 10px;\n}\n\n.value{\n    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    font-size: 16px;\n    /* color: var(--unnamed-color-3b3b3b); */\n    text-align: left;\n    /* font: normal normal normal 16px/18px Helvetica Neue; */\n    letter-spacing: 0px;\n    color: #3B3B3B;\n    opacity: 1;\n    margin-left: 20px;\n}\n\n.line {\n    border:none;\n    border-top:3px dashed #A0D7C7;\n    color:#fff;\n    background-color:#fff;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 17px;\n    margin-bottom: 17px;\n  }\n\n.list-group {\n    margin-top: 10px;\n    /* max-height: 400px; */\n    max-height: 55vh;\n    margin-bottom: 10px;\n    overflow-y:scroll;\n    outline: none;\n}\n\n.list-group-item:hover , .active, .highlight{\n    background: var(--unnamed-color-f7ead3) 0% 0% no-repeat padding-box;\n    background: #F7EAD3 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 2.5px;\n    margin-top: 2.5px;\n    width: 200px !important;\n    height: 40px !important;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    text-align: start;\n}\n\n.inactive{\n    background: var(--unnamed-color-f7ead3) 0% 0% no-repeat padding-box;\n    background: white 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 2.5px;\n    margin-top: 2.5px;\n    width: 200px !important;\n    height: 40px !important;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    text-align: start;\n}\n\n.list-group-item{\n    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    height: 40px !important;\n    width: 200px !important;\n    margin-left: 20px;\n    margin-right: 0px;\n    margin-bottom: 2.5px;\n    margin-top: 2.5px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    /* color: black; */\n    font-size: 16px;\n    /* font: normal normal normal 16px/18px Helvetica Neue; */\n    /* color: var(--unnamed-color-3b3b3b); */\n    /* text-align: left; */\n\n    letter-spacing: 0px;\n    color: #3B3B3B;\n    opacity: 1;\n    border: none;\n    text-align: start;\n}\n\n\n/* @media only screen and (max-width: 1940px) {\n    .list-group {\n        max-height: 570px !important;\n    }\n}\n@media only screen and (max-width: 1710px) {\n    .list-group {\n        max-height: 470px !important;\n    }\n}\n@media only screen and (max-width: 1610px) {\n    .list-group {\n        max-height: 420px !important;\n    }\n} */\n/**mac screen*/\n/* @media only screen and (max-width: 1580px) {\n    .list-group {\n        max-height: 560px !important;\n    }\n}\n@media only screen and (max-width: 1430px) {\n    .list-group {\n        max-height: 335px !important;\n    }\n} */\n/**mac screen*/\n/* @media only screen and (max-width: 1390px) {\n    .list-group {\n        max-height: 460px !important;\n    }\n} */\n/**mac screen*/\n/* @media only screen and (max-width: 1310px) {\n    .list-group {\n        max-height: 410px !important;\n    }\n}\n@media only screen and (max-width: 1290px) {\n    .list-group {\n        max-height: 260px !important;\n    }\n} */\n/**mac screen*/\n/* @media only screen and (max-width: 1160px) {\n    .list-group {\n        max-height: 340px !important;\n    }\n} */\n/**mac screen*/\n/* @media only screen and (max-width: 1040px) {\n    .list-group {\n        max-height: 260px !important;\n    }\n} */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
